"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var MultiSelect = function MultiSelect() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.317.659a2.194 2.194 0 010 3.182l-10.89 10.5a2.395 2.395 0 01-3.3 0l-5.444-5.25a2.194 2.194 0 010-3.182 2.395 2.395 0 013.3 0l3.795 3.659L19.017.659a2.395 2.395 0 013.3 0z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.317 9.659a2.194 2.194 0 010 3.182l-10.89 10.5a2.395 2.395 0 01-3.3 0l-5.444-5.25a2.194 2.194 0 010-3.182 2.395 2.395 0 013.3 0l3.795 3.659 9.239-8.909a2.395 2.395 0 013.3 0z",
    clipRule: "evenodd",
    opacity: "0.65"
  }));
};

exports.MultiSelect = MultiSelect;